import React from 'react';
import { useAppContext } from 'providers/AppProvider';
import GoogleMap from 'components/map/GoogleMap';
import PropTypes from 'prop-types';

const MapDark = ({ template }) => {
  return (
    <GoogleMap
      initialCenter={{
        lat: Number(template?.latitude),
        lng: Number(template?.longitude)
      }}
      mapStyle="Cobalt"
      className="vh-50 rounded-soft mt-5"
    />
  );
};
MapDark.propTypes = {
  template: PropTypes.any
};

const MapLight = ({ template }) => {
  return (
    <GoogleMap
      initialCenter={{
        lat: Number(template?.latitude),
        lng: Number(template?.longitude)
      }}
      mapStyle="Default"
      className="vh-50 rounded-soft mt-5"
    ></GoogleMap>
  );
};
MapLight.propTypes = {
  template: PropTypes.any
};

const TemplateDetailsGmap = ({ template }) => {
  const {
    config: { isDark }
  } = useAppContext();
  console.log(template);
  return (
    <>
      {isDark ? (
        <MapDark template={template} />
      ) : (
        <MapLight template={template} />
      )}
    </>
  );
};

TemplateDetailsGmap.propTypes = {
  template: PropTypes.any
};

export default TemplateDetailsGmap;
